import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "border border-gray-200 rounded-lg overflow-hidden" }
const _hoisted_2 = { class: "bg-gray-50 p-4 flex justify-between items-center" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "flex flex-col text-left" }
const _hoisted_5 = { class: "text-gray-700 font-inter text-lg font-normal" }
const _hoisted_6 = { class: "text-gray-700 font-inter text-lg font-normal" }
const _hoisted_7 = { class: "flex items-center gap-3" }
const _hoisted_8 = { class: "flex gap-1" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col ml-5 w-[30%] max-md:ml-0 max-md:w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_DirectoryPreview = _resolveComponent("DirectoryPreview")!
  const _component_DirectoryControls = _resolveComponent("DirectoryControls")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, " Name: " + _toDisplayString(_ctx.layout.layoutName), 1),
          _createElementVNode("span", _hoisted_6, " Type: " + _toDisplayString(_ctx.layout.layoutType) + " | Views: " + _toDisplayString(_ctx.layout.viewCount), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_BaseButton, {
          type: "button",
          class: "text-primary-purple font-inter text-sm font-medium",
          onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('showCode', _ctx.layout.uuid))
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode(" Setup Code ")
          ])),
          _: 1
        }),
        _createVNode(_component_BaseButton, {
          type: "button",
          class: "text-primary-purple font-inter text-sm font-medium",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggleExpanded', _ctx.layout.id)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.expandedLayoutId === _ctx.layout.id ? "Collapse" : "Edit"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_BaseButton, {
          type: "button",
          class: "text-red-700 font-inter text-sm font-medium ml-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('delete', _ctx.layout.id)))
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode(" Delete ")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("section", {
        class: _normalizeClass(["flex flex-col max-md:ml-0 max-md:w-full", {
          'w-full': _ctx.expandedLayoutId !== _ctx.layout.id,
          'w-[70%]': _ctx.expandedLayoutId === _ctx.layout.id,
        }])
      }, [
        _createVNode(_component_DirectoryPreview, {
          layout: _ctx.layout,
          profiles: _ctx.profiles,
          approvedExperts: _ctx.approvedExperts,
          userStore: _ctx.userStore,
          expandedLayoutId: _ctx.expandedLayoutId
        }, null, 8, ["layout", "profiles", "approvedExperts", "userStore", "expandedLayoutId"])
      ], 2),
      (_ctx.expandedLayoutId === _ctx.layout.id)
        ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
            _createVNode(_component_DirectoryControls, {
              layout: _ctx.layout,
              approvedExperts: _ctx.approvedExperts,
              fieldErrors: _ctx.fieldErrors,
              updateDirectoryLoading: _ctx.updateDirectoryLoading,
              userStore: _ctx.userStore,
              onUpdate: _cache[3] || (_cache[3] = (updatedLayout) => _ctx.$emit('update', updatedLayout)),
              onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('cancelEdit'))),
              onUpdateLayoutName: _cache[5] || (_cache[5] = (id, name) => _ctx.$emit('updateLayoutName', id, name)),
              onUpdateLayoutType: _cache[6] || (_cache[6] = (id, type) => _ctx.$emit('updateLayoutType', id, type)),
              onUpdateLayoutStyle: _cache[7] || (_cache[7] = 
            (id, style) => _ctx.$emit('updateLayoutStyle', id, style)
          ),
              onUpdateLayoutCosmetic: _cache[8] || (_cache[8] = 
            (id, property, value) =>
              _ctx.$emit('updateLayoutCosmetic', id, property, value)
          ),
              onUpdateLayoutHeader: _cache[9] || (_cache[9] = 
            (id, property, value) =>
              _ctx.$emit('updateLayoutHeader', id, property, value)
          ),
              onUpdateLayoutWebsite: _cache[10] || (_cache[10] = 
            (id, url) => _ctx.$emit('updateLayoutWebsite', id, url)
          ),
              onUpdateLayoutSearchFilters: _cache[11] || (_cache[11] = 
            (id, enabled) => _ctx.$emit('updateLayoutSearchFilters', id, enabled)
          ),
              onUpdateLayoutSelectedExperts: _cache[12] || (_cache[12] = 
            (id, ids, fieldIndex) =>
              _ctx.$emit('updateLayoutSelectedExperts', id, ids, fieldIndex)
          ),
              onUpdateLayoutRandomExperts: _cache[13] || (_cache[13] = 
            (id, isRandom) => _ctx.$emit('updateLayoutRandomExperts', id, isRandom)
          )
            }, null, 8, ["layout", "approvedExperts", "fieldErrors", "updateDirectoryLoading", "userStore"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [_vShow, _ctx.expandedLayoutId === null || _ctx.expandedLayoutId === _ctx.layout.id]
  ])
}